import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Keyboard } from 'swiper'

import Erigo from 'assets/image/testimoni/erigo.png'
import Halodoc from 'assets/image/testimoni/halodoc.png'
import Decathlon from 'assets/image/testimoni/decathlon.png'
// import ManuvaRetail from 'assets/image/testimoni/manuva-retail.png'

import ErigoTablet from 'assets/image/testimoni/erigo-mobile.png'
import HalodocTablet from 'assets/image/testimoni/halodoc-mobile.png'
import DecathlonTablet from 'assets/image/testimoni/decathlon-mobile.png'
// import ManuvaRetailTablet from 'assets/image/testimoni/manuva-retail-mobile.png'

const Testimoni = () => {
  const arrTestimoni = [
    {
      img: {
        desktop: Erigo,
        tablet: ErigoTablet
      },
      profile: {
        name: 'Hari Budiatsanoor',
        position: 'Operational Director of Toko Ziran Berkah'
      },
      layanan: 'Super Merchant Fesyen dan Pakaian no.1 di Shopee dan Tokopedia',
      testimoni:
        '“Harga terbaik, pengiriman baik, praktis cara pemesanan, yang kerennya punya aplikasi sendiri”',
      wallet: {
        start: 5,
        current: 80
      }
    },
    {
      img: {
        desktop: Halodoc,
        tablet: HalodocTablet
      },
      profile: {
        name: 'Hari Budiatsanoor',
        position: 'Operational Director of Toko CP Plastik'
      },
      layanan: 'Teknologi Kesehatan no.1 di Indonesia',
      testimoni: '“Dapat diandalkan, pengiriman tepat waktu, pembaruan tingkat stok cukup akurat di aplikasi, respon sales cukup bagus, overall puas dengan service-nya”',
      wallet: {
        start: 3,
        current: 30
      }
    },
    {
      img: {
        desktop: Decathlon,
        tablet: DecathlonTablet
      },
      profile: {
        name: 'Hari Budiatsanoor',
        position: 'Operational Director of Toko 91 Plastik'
      },
      layanan: 'Retailer Produk Olahraga',
      testimoni:
        '“Tjetak (Manuva) memiliki pengiriman tercepat sejauh ini dan juga memiliki program menarik yang memicu keinginan kami untuk bersaing”.',
      wallet: {
        start: 3,
        current: 13
      }
    }
  ]

  // const [activeIndex, setActiveIndex] = useState(15)
  const [nextNavTestimoniIsHover, setNextNavTestimoniHover] = useState(false)
  const [prevNavTestimoniIsHover, setPrevNavTestimoniHover] = useState(false)

  return (
    <section
      id="testimoni"
      className="pt-10 pb-20 lg:py-20 xl:py-[88px] max-w-[1440px] m-auto"
    >
      <div className="px-6 lg:px-14 xl:px-[120px] mb-[32px] lg:mb-[32px] xl:mb-[61px]">
        <h1 className="h4-bold xl:h3-bold md:text-[40px] text-center max-w-[773px] sm:w-full text-[#101838] m-auto left-0 right-0">
          Apa Kata Mereka Yang Sudah Bergabung dengan Manuva Retail?
        </h1>
      </div>

      <div className="relative px-6 lg:px-14 xl:px-[120px]">
        <button
          className="hidden md:grid bg-white place-content-center absolute md:w-[37px] xl:w-[48px] md:h-[37px] xl:h-[48px] origin-center left-0 z-10 lg:left-[60px] top-[50%] translate-y-[-50%] border border-neutral-50 rounded-[100%] p-3 prev-testimoni hover:bg-[#F4633A] hover:border-[#F4633A]"
          onMouseEnter={() => setPrevNavTestimoniHover(true)}
          onMouseLeave={() => setPrevNavTestimoniHover(false)}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.9998 19.9201L8.47984 13.4001C7.70984 12.6301 7.70984 11.3701 8.47984 10.6001L14.9998 4.08008"
              stroke={prevNavTestimoniIsHover ? 'white' : '#101838'}
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <button
          className="hidden md:grid bg-white place-content-center absolute md:w-[37px] xl:w-[48px] md:h-[37px] xl:h-[48px] origin-center right-0 z-10 lg:right-[60px] top-[50%] translate-y-[-50%] border border-neutral-50 rounded-[100%] p-3 next-testimoni hover:bg-[#F4633A] hover:border-[#F4633A]"
          onMouseEnter={() => setNextNavTestimoniHover(true)}
          onMouseLeave={() => setNextNavTestimoniHover(false)}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.91016 19.9201L15.4302 13.4001C16.2002 12.6301 16.2002 11.3701 15.4302 10.6001L8.91016 4.08008"
              stroke={nextNavTestimoniIsHover ? 'white' : '#101838'}
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <Swiper
          id="testimoni-swiper"
          className=""
          slidesPerView="auto"
          onSlideChange={(swiper) => {
            // setActiveIndex(swiper.activeIndex)
            console.log(swiper.activeIndex)
          }}
          onSwiper={(swiper) => {
            // setActiveIndex(swiper.activeIndex)
            swiper.slideTo(0, 0)
            console.log(swiper.activeIndex)
          }}
          // cssMode={true}
          navigation={{
            prevEl: '.prev-testimoni',
            nextEl: '.next-testimoni',
            clickable: true
          }}
          // navigation={true}
          mousewheel={false}
          keyboard={true}
          modules={[Navigation, Keyboard]}
          loop={true}
          breakpoints={{
            375: {
              initialSlide: 12
            },
            1280: {
              initialSlide: 11
            }
          }}
        >
          {arrTestimoni.map(
            ({ img, profile, layanan, testimoni, wallet }, index) => {
              return (
                <SwiperSlide
                  key={index}
                  className="max-w-[80%] md:max-w-[31.33%] md:my-2 lg:my-8 flex flex-row mx-4 min-h-[262px] max-h-[262px]"
                >
                  <div
                    className="bg-white p-6 flex flex-col rounded-xl"
                    style={{ boxShadow: '0px 4px 32px rgba(0, 0, 0, 0.05)' }}
                  >
                    <div className="flex-1">
                      <p className="mt-4 text-neutral-100 text-s-reguler overflow-ellipsis">
                        {testimoni}
                      </p>
                    </div>
                    <div className="mt-[24px] pt-[24px] border-t border-neutral-30 flex justify-between items-center">
                      <div className="flex gap-x-3 items-start">
                        <div className="w-12 h-12 p-3 bg-[#F7F8FA] rounded-[100%]">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
                              fill="#969FB6"
                            />
                            <path
                              d="M12.0002 14.5C6.99016 14.5 2.91016 17.86 2.91016 22C2.91016 22.28 3.13016 22.5 3.41016 22.5H20.5902C20.8702 22.5 21.0902 22.28 21.0902 22C21.0902 17.86 17.0102 14.5 12.0002 14.5Z"
                              fill="#969FB6"
                            />
                          </svg>
                        </div>

                        <div className="overflow-hidden overflow-ellipsis">
                          <h1 className="text-[#101838] font-bold leading-[150%] text-sm w-[9999%]">
                            {profile.name}
                          </h1>
                          <p className="text-[#101838] font-normal leading-[150%] text-xs mt-[2px] w-[9999%]">
                            {profile.position}
                          </p>
                        </div>
                      </div>

                      {/* <div className="hidden md:flex gap-x-1">
                        <StarIcon />
                        <p className="text-s-medium text-primary-main">5.0</p>
                      </div> */}
                    </div>
                  </div>
                </SwiperSlide>
              )
            }
          )}
        </Swiper>
      </div>
    </section>
  )
}

const StarIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.04917 3.92731C9.34852 3.006 10.6519 3.006 10.9513 3.92731L12.0209 7.21911C12.1547 7.63113 12.5387 7.91009 12.9719 7.91009H16.4331C17.4018 7.91009 17.8046 9.14971 17.0209 9.71911L14.2207 11.7535C13.8702 12.0082 13.7236 12.4596 13.8575 12.8716L14.927 16.1634C15.2264 17.0847 14.1719 17.8508 13.3882 17.2814L10.588 15.247C10.2375 14.9923 9.76293 14.9923 9.41244 15.247L6.61227 17.2814C5.82856 17.8508 4.77408 17.0847 5.07343 16.1634L6.143 12.8716C6.27688 12.4596 6.13022 12.0082 5.77973 11.7535L2.97956 9.71911C2.19585 9.14971 2.59862 7.91009 3.56735 7.91009H7.02855C7.46177 7.91009 7.84573 7.63113 7.9796 7.21911L9.04917 3.92731Z"
        fill="#FFB946"
      />
    </svg>
  )
}

StarIcon.propTypes = {
  className: PropTypes.string
}

export default Testimoni
